import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
import bcrypt from 'bcryptjs';

const ROLLER = ['yonetici', 'operasyon', 'depo', 'muhasebeci', 'surucu', 'dagitimci', 'musteri'];

const BOSH_FORM = { ad: '', email: '', sifre: '', rol: 'surucu', durum: 'Aktif', depo_sehir: 'İstanbul' };
const DEPO_SEHIRLER = ['İstanbul', 'Kayseri', 'Mersin'];

function Kullanicilar() {
  const [kullanicilar, setKullanicilar] = useState([]);
  const [yukleniyor, setYukleniyor]     = useState(true);
  const [yeniModal, setYeniModal]       = useState(false);
  const [duzenleModal, setDuzenleModal] = useState(null); // düzenlenecek kullanıcı objesi
  const [form, setForm]                 = useState(BOSH_FORM);
  const [kayitYapiliyor, setKayitYapiliyor] = useState(false);

  useEffect(() => { kullanicilariGetir(); }, []);

  const kullanicilariGetir = async () => {
    setYukleniyor(true);
    const { data } = await supabase
      .from('kullanicilar')
      .select('*')
      .order('created_at', { ascending: false });
    if (data) setKullanicilar(data);
    setYukleniyor(false);
  };

  // ── Yeni kullanıcı ekle ──────────────────────────────────
  const kullaniciEkle = async () => {
    if (!form.ad.trim())    return alert('Ad zorunlu!');
    if (!form.email.trim()) return alert('Email zorunlu!');
    if (!form.sifre.trim()) return alert('Şifre zorunlu!');
    setKayitYapiliyor(true);
    const { error } = await supabase.from('kullanicilar').insert([{
      ad: form.ad.trim(),
      email: form.email.trim(),
      sifre: bcrypt.hashSync(form.sifre.trim(), 10),
      rol: form.rol,
      durum: form.durum,
      depo_sehir: form.rol === 'depo' ? (form.depo_sehir || 'İstanbul') : null,
    }]);
    setKayitYapiliyor(false);
    if (error) { alert('Hata: ' + error.message); return; }
    setYeniModal(false);
    setForm(BOSH_FORM);
    kullanicilariGetir();
  };

  // ── Kullanıcı güncelle ───────────────────────────────────
  const kullaniciGuncelle = async () => {
    if (!duzenleModal.ad.trim())    return alert('Ad zorunlu!');
    if (!duzenleModal.email.trim()) return alert('Email zorunlu!');
    setKayitYapiliyor(true);
    const guncelleme = {
      ad:         duzenleModal.ad.trim(),
      email:      duzenleModal.email.trim(),
      rol:        duzenleModal.rol,
      durum:      duzenleModal.durum,
      depo_sehir: duzenleModal.rol === 'depo' ? (duzenleModal.depo_sehir || 'İstanbul') : null,
    };
    // Şifre doluysa güncelle, boşsa dokunma
    if (duzenleModal.yeniSifre && duzenleModal.yeniSifre.trim()) {
      guncelleme.sifre = bcrypt.hashSync(duzenleModal.yeniSifre.trim(), 10);
    }
    const { error } = await supabase.from('kullanicilar').update(guncelleme).eq('id', duzenleModal.id);
    setKayitYapiliyor(false);
    if (error) { alert('Hata: ' + error.message); return; }
    setDuzenleModal(null);
    kullanicilariGetir();
  };

  // ── Kullanıcı sil ────────────────────────────────────────
  const kullaniciSil = async (id, ad) => {
    if (!window.confirm(`"${ad}" adlı kullanıcıyı silmek istediğinize emin misiniz?`)) return;

    const { error: dagErr } = await supabase.from('seferler').update({ dagitimci_id: null }).eq('dagitimci_id', id);
    if (dagErr) { alert('Hata (dagitimci_id): ' + dagErr.message); return; }

    const { error: surErr } = await supabase.from('seferler').update({ surucu_id: null }).eq('surucu_id', id);
    if (surErr) { alert('Hata (surucu_id): ' + surErr.message); return; }

    const { error } = await supabase.from('kullanicilar').delete().eq('id', id);
    if (error) { alert('Hata: ' + error.message); return; }
    kullanicilariGetir();
  };

  const durumRenk = (durum) =>
    durum === 'Aktif'
      ? { bg: '#F0FDF4', renk: '#3B6D11' }
      : { bg: '#f1f1f1', renk: '#888' };

  const rolEtiket = (rol) => {
    const map = { yonetici: 'Yönetici', operasyon: 'Operasyon Yöneticisi', depo: 'Depo', muhasebeci: 'Muhasebeci', surucu: 'Sürücü', dagitimci: 'Dağıtımcı', musteri: 'Müşteri' };
    return map[rol] || rol;
  };

  return (
    <div style={{ flex: 1, background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
      {/* Başlık */}
      <div style={{ background: '#fff', padding: '14px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Kullanıcı Yönetimi</div>
        <button onClick={() => { setForm(BOSH_FORM); setYeniModal(true); }}
          style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
          + Yeni Kullanıcı
        </button>
      </div>

      <div style={{ padding: '24px' }}>
        <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #eee', overflow: 'hidden' }}>
          {yukleniyor ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Yükleniyor...</div>
          ) : kullanicilar.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Kullanıcı bulunamadı.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f9f9f9' }}>
                  {['Ad', 'Email', 'Rol', 'Durum', 'İşlem'].map((h, i) => (
                    <th key={i} style={{ padding: '10px 20px', textAlign: 'left', color: '#888', fontWeight: '500', fontSize: '12px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {kullanicilar.map((k) => {
                  const { bg, renk } = durumRenk(k.durum || 'Aktif');
                  return (
                    <tr key={k.id} style={{ borderTop: '1px solid #eee' }}>
                      <td style={{ padding: '12px 20px', fontWeight: '600', color: '#1a1a1a' }}>{k.ad}</td>
                      <td style={{ padding: '12px 20px', color: '#555' }}>{k.email}</td>
                      <td style={{ padding: '12px 20px' }}>
                        <span style={{ background: '#E6F1FB', color: '#185FA5', padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>
                          {rolEtiket(k.rol)}{k.rol === 'depo' && k.depo_sehir ? ` • ${k.depo_sehir}` : ''}
                        </span>
                      </td>
                      <td style={{ padding: '12px 20px' }}>
                        <span style={{ background: bg, color: renk, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>
                          {k.durum || 'Aktif'}
                        </span>
                      </td>
                      <td style={{ padding: '12px 20px' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button onClick={() => setDuzenleModal({ ...k, yeniSifre: '' })}
                            style={{ background: 'none', border: '1px solid #ddd', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', color: '#555' }}>
                            ✏️ Düzenle
                          </button>
                          <button onClick={() => kullaniciSil(k.id, k.ad)}
                            style={{ background: 'none', border: '1px solid #fcc', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', color: '#cc0000' }}>
                            🗑️ Sil
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* ── Yeni Kullanıcı Modal ── */}
      {yeniModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '460px', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#0D3B7A' }}>Yeni Kullanıcı Ekle</div>
              <button onClick={() => setYeniModal(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <ModalForm form={form} setForm={setForm} yeniKayit />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setYeniModal(false)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>İptal</button>
              <button onClick={kullaniciEkle} disabled={kayitYapiliyor}
                style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', opacity: kayitYapiliyor ? 0.7 : 1 }}>
                {kayitYapiliyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Düzenle Modal ── */}
      {duzenleModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '460px', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#0D3B7A' }}>Kullanıcı Düzenle</div>
              <button onClick={() => setDuzenleModal(null)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <ModalForm form={duzenleModal} setForm={setDuzenleModal} />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setDuzenleModal(null)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>İptal</button>
              <button onClick={kullaniciGuncelle} disabled={kayitYapiliyor}
                style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', opacity: kayitYapiliyor ? 0.7 : 1 }}>
                {kayitYapiliyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Ortak form bileşeni ──────────────────────────────────────
function ModalForm({ form, setForm, yeniKayit }) {
  const inputStyle = { width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '12px', fontWeight: '500', marginBottom: '6px', display: 'block' };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      <div style={{ gridColumn: '1 / -1' }}>
        <label style={labelStyle}>Ad Soyad *</label>
        <input value={form.ad || ''} onChange={e => setForm({ ...form, ad: e.target.value })}
          placeholder="Ahmet Kara" style={inputStyle} />
      </div>
      <div style={{ gridColumn: '1 / -1' }}>
        <label style={labelStyle}>Email *</label>
        <input value={form.email || ''} onChange={e => setForm({ ...form, email: e.target.value })}
          placeholder="ahmet@byrsword.com" type="email" style={inputStyle} />
      </div>
      <div style={{ gridColumn: '1 / -1' }}>
        <label style={labelStyle}>{yeniKayit ? 'Şifre *' : 'Yeni Şifre (boş bırakılırsa değişmez)'}</label>
        <input value={yeniKayit ? (form.sifre || '') : (form.yeniSifre || '')}
          onChange={e => setForm(yeniKayit ? { ...form, sifre: e.target.value } : { ...form, yeniSifre: e.target.value })}
          placeholder={yeniKayit ? 'Şifre girin' : 'Değiştirmek için yeni şifre girin'}
          type="password" style={inputStyle} />
      </div>
      <div>
        <label style={labelStyle}>Rol</label>
        <select value={form.rol || 'surucu'} onChange={e => setForm({ ...form, rol: e.target.value })}
          style={{ ...inputStyle, padding: '8px' }}>
          {[
            { val: 'yonetici',   label: 'Yönetici' },
            { val: 'operasyon',  label: 'Operasyon Yöneticisi' },
            { val: 'depo',       label: 'Depo' },
            { val: 'muhasebeci', label: 'Muhasebeci' },
            { val: 'surucu',     label: 'Sürücü' },
            { val: 'dagitimci',  label: 'Dağıtımcı' },
            { val: 'musteri',    label: 'Müşteri' },
          ].map(r => <option key={r.val} value={r.val}>{r.label}</option>)}
        </select>
      </div>
      <div>
        <label style={labelStyle}>Durum</label>
        <select value={form.durum || 'Aktif'} onChange={e => setForm({ ...form, durum: e.target.value })}
          style={{ ...inputStyle, padding: '8px' }}>
          <option value="Aktif">Aktif</option>
          <option value="Pasif">Pasif</option>
        </select>
      </div>
      {/* Depo şehri — sadece depo rolünde görünür */}
      {form.rol === 'depo' && (
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={labelStyle}>Depo Şehri</label>
          <select value={form.depo_sehir || 'İstanbul'} onChange={e => setForm({ ...form, depo_sehir: e.target.value })}
            style={{ ...inputStyle, padding: '8px' }}>
            {DEPO_SEHIRLER.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      )}
    </div>
  );
}

export default Kullanicilar;
